var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTooltip",
    {
      attrs: {
        arrow: false,
        content: _vm.textTooltip,
        placement: _vm.tooltipPlacement
      }
    },
    [
      _vm._t("default", [
        _c("CompassIconButton", {
          class: _vm.buttonClasses,
          attrs: { size: "small", icon: _vm.icon },
          on: { click: _vm.copyToClipboard }
        })
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }